module.exports = __webpack_public_path__ + "static/media/java.4aa9a54d.svg";